export { default as Footer } from "./footer";
export type { FooterProps } from "./footer";
